module.exports = __webpack_public_path__ + "img/خلاق.3ea9b959.png";